/* Brida slide cart behaviour (markup: snippets/cart-drawer.liquid).
   Opening/closing stays with Dawn's <cart-drawer> (assets/cart-drawer.js); this file adds:
   - opens the drawer after ANY add to cart on the page (Replo buttons, Kaching widget, other scripts):
     it watches fetch/XHR calls to /cart/add, the job Kaching Cart did before
   - +/- work like Kaching Cart: one /cart/update.js per click with the line's current key, the drawer is
     locked (dimmed prices, disabled buttons, spinner on checkout) until the cart answers. Kaching changes a
     line's key whenever its quantity changes, so keys always come from the latest render.
   - shipping insurance toggle (add / remove its own cart line)
   - removing the last item closes the drawer and drops the insurance; the cart icon on an empty cart
     opens the empty state */
(function () {
  if (window.bridaCart) return;
  window.bridaCart = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var OWN = 'X-Brida-Cart';     // marks our own requests so the add-to-cart watcher ignores them
  var seq = 0;                  // bumps on every render source; stale refreshes are dropped
  var loading = false;          // like Kaching Cart: one change at a time, the drawer is locked meanwhile

  // Microsoft Clarity custom events (Clarity is on the store): see what customers actually use in the cart
  function track(name) { try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (err) {} }

  function drawer() { return document.querySelector('cart-drawer'); }
  function state() { return document.querySelector('[data-bc-state]'); }
  function count() { var s = state(); return s ? parseInt(s.dataset.count, 10) || 0 : 0; }
  function routes() { return window.routes || { cart_add_url: '/cart/add', cart_update_url: '/cart/update' }; }
  function updateUrl() { return routes().cart_update_url || '/cart/update'; }

  function parse(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  // Locked: prices dim, every control is disabled, the checkout button spins
  function lock(on) {
    loading = on;
    var s = state();
    if (!s) return;
    s.classList.toggle('is-updating', on);
    s.querySelectorAll('[data-bc-qty], [data-bc-ins], [data-bc-checkout]').forEach(function (el) { el.disabled = on; });
  }

  function render(sections) {
    if (!sections) return;
    var fresh = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
    var current = document.getElementById('CartDrawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;   // fresh HTML = fresh line keys

    var bubble = document.getElementById('cart-icon-bubble');
    var freshBubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    remember();

    if (count() === 0) {
      var s = state();
      if (s && s.dataset.insKey) change(s.dataset.insKey, 0);   // insurance never stays alone
      if (drawer()) drawer().close();
    }
  }

  var TIMEOUT = 10000;           // a change that takes longer than this counts as failed
  var lastGood = null;           // drawer HTML of the last confirmed cart state

  function remember() {
    var cur = document.getElementById('CartDrawer');
    if (cur) lastGood = cur.innerHTML;
  }

  function showError() {
    var s = state();
    var items = document.querySelector('.bc__items');
    if (!s || !items) return;
    var old = items.querySelector('.bc-msg');
    if (old) old.remove();
    var msg = document.createElement('p');
    msg.className = 'bc-msg';
    msg.setAttribute('role', 'alert');
    msg.textContent = s.dataset.errorText || 'Something went wrong. Please try again.';
    items.insertBefore(msg, items.firstChild);
    setTimeout(function () { if (msg.parentNode) msg.remove(); }, 6000);
  }

  // Failed or too slow: back to the last correct state, unlock, tell the customer,
  // then quietly re-read the cart in case the change did go through
  function fail() {
    var cur = document.getElementById('CartDrawer');
    if (cur && lastGood !== null) cur.innerHTML = lastGood;
    lock(false);
    showError();
    refresh(false).then(showError, function () {});
  }

  function post(url, body) {
    lock(true);
    seq++;
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[OWN] = '1';
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        clearTimeout(timer);
        loading = false;
        if (res.ok && res.data.sections) render(res.data.sections);   // render replaces the locked controls
        else fail();
      })
      .catch(function () { clearTimeout(timer); loading = false; fail(); });
  }

  // Same call Kaching Cart makes: /cart/update.js with the line's current key
  function change(key, qty) {
    var updates = {};
    updates[key] = qty;
    return post(updateUrl(), { updates: updates });
  }

  // Re-read the drawer from the cart (after someone else changed it), optionally open it
  function refresh(openAfter) {
    var id = ++seq;
    var url = window.location.pathname + '?sections=' + SECTIONS.join(',');
    var headers = {};
    headers[OWN] = '1';
    return fetch(url, { headers: headers })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (id !== seq) return;
        render(sections);
        if (openAfter && count() > 0 && drawer()) drawer().open();
      })
      .finally(function () { if (id === seq) lock(false); });
  }

  /* ---------- +/- : one change at a time, clicks while loading are ignored ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bc-qty]');
    if (btn) {
      if (loading) return;
      var line = btn.closest('.bc-item');
      var out = line ? line.querySelector('output') : null;
      var cur = out ? parseInt(out.textContent, 10) : 0;
      track(btn.hasAttribute('data-bc-remove') ? 'cart_remove' : (parseInt(btn.dataset.qty, 10) > cur ? 'cart_plus' : 'cart_minus'));
      if (out) out.textContent = btn.dataset.qty;
      change(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      return;
    }
    if (e.target.closest('[data-bc-checkout]') && loading) { e.preventDefault(); return; }
    if (e.target.closest('[data-bc-checkout]')) track('cart_checkout');
    if (e.target.closest('[data-bc-close]') || e.target.id === 'CartDrawer-Overlay') {
      if (drawer()) drawer().close();
    }
  });

  /* ---------- shipping insurance toggle ---------- */
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-bc-ins]');
    if (!box) return;
    if (loading) { box.checked = !box.checked; return; }
    var s = state();
    track(box.checked ? 'cart_insurance_on' : 'cart_insurance_off');
    if (box.checked) post(routes().cart_add_url, { items: [{ id: parseInt(s.dataset.insVariant, 10), quantity: 1 }] });
    else if (s.dataset.insKey) change(s.dataset.insKey, 0);
  });

  // An empty cart opens too: the drawer shows "Your cart is empty" + a button that only closes it (QA BUG-13).
  // Removing the last item still slides the drawer shut (see render).
  remember();

  /* ---------- keep the cart icon and drawer in step with the real cart ---------- */
  // A page can come back from the browser's memory (back button, a tab left open, a cached copy) with an
  // old cart in its HTML: the red count bubble is missing although the cart is full. Ask Shopify what is
  // really in the cart and re-render when it differs.
  var INS_HANDLES = ['shipping-insurance', 'kaching-cart-toggle'];   // keep in sync with snippets/brida-cart-icon.liquid
  function sync() {
    if (loading) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var headers = {};
    headers[OWN] = '1';
    fetch(root + 'cart.js', { headers: headers, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        (cart.items || []).forEach(function (it) { if (INS_HANDLES.indexOf(it.handle) === -1) n += it.quantity; });
        if (n !== count() && !loading) refresh(false);
      })
      .catch(function () {});
  }
  sync();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(); });

  // Insurance never stays alone: if a page loads with only the insurance line (e.g. products removed on /cart), drop it
  (function () {
    var s = state();
    if (s && count() === 0 && s.dataset.insKey) change(s.dataset.insKey, 0);
  })();


  /* ---------- add to cart failed: stay on the page, short message at the bottom ---------- */
  // Kaching Cart shows nothing in this case, Dawn would send the customer to the /cart page.
  function toast(message) {
    var s = state();
    var text = message || (s && s.dataset.errorText) || 'Something went wrong. Please try again.';
    var old = document.querySelector('.bc-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'bc-toast';
    el.setAttribute('role', 'alert');
    el.textContent = text;
    el.addEventListener('click', function () { el.remove(); });
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () { el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 300); }, 5000);
  }
  function toastFrom(data) { toast(data && (data.description || data.message)); }

  /* ---------- every add-to-cart form opens the slide cart, never the /cart page ---------- */
  // Runs last (window, bubble phase). If Dawn's product form or Kaching already handled the submit
  // (defaultPrevented), leave it: the fetch watcher below opens the drawer. Otherwise we add it ourselves.
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    e.preventDefault();

    var data = new FormData(form);
    if (e.submitter && e.submitter.name) data.append(e.submitter.name, e.submitter.value || '');
    data.append('sections', SECTIONS.join(','));
    data.append('sections_url', window.location.pathname);
    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    headers[OWN] = '1';
    fetch(routes().cart_add_url, { method: 'POST', headers: headers, body: data })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) openFrom(res.data);
        else toastFrom(res.data);
      })
      .catch(function () { toast(); });   // network error: never fall back to the /cart page
  });

  /* ---------- open after any add to cart on the page ---------- */
  // Dawn's own product form sends 'sections' and opens the drawer itself: leave those alone.
  function isForeignAdd(url, method, body, headers) {
    if (!url || !/\/cart\/add(\.js)?(\?|$)/.test(String(url).split('#')[0].replace(/^https?:\/\/[^/]+/, ''))) return false;
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    if (headers && (headers[OWN] || (headers.get && headers.get(OWN)))) return false;
    if (body instanceof FormData && body.has('sections')) return false;
    if (typeof body === 'string' && body.indexOf('"sections"') !== -1) return false;
    return true;
  }

  // Opens the drawer straight from the add response when possible (one round trip instead of two)
  function openFrom(data) {
    if (data && data.sections && data.sections['cart-drawer']) {
      seq++;
      render(data.sections);
      lock(false);
      if (count() > 0 && drawer()) drawer().open();
    } else {
      refresh(true);
    }
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var method = (init && init.method) || (input && input.method);
    if (!isForeignAdd(url, method, init && init.body, init && init.headers)) return nativeFetch.apply(this, arguments);

    // JSON body: ask Shopify to send our sections back with the add response
    var args = arguments;
    if (init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        body.sections = SECTIONS;
        body.sections_url = window.location.pathname;
        args = [input, Object.assign({}, init, { body: JSON.stringify(body) })];
      } catch (err) { /* not JSON: fall back to a second request */ }
    }
    var p = nativeFetch.apply(this, args);
    p.then(function (r) {
      if (!r.ok) { r.clone().json().then(toastFrom, function () { toast(); }); return; }
      r.clone().json().then(openFrom, function () { refresh(true); });
    }, function () { toast(); });
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._bcMethod = method;
    this._bcUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (isForeignAdd(this._bcUrl, this._bcMethod, body)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) return refresh(true);
        try { toastFrom(JSON.parse(this.responseText)); } catch (err) { toast(); }
      });
    }
    return xhrSend.apply(this, arguments);
  };
})();
